// extracted by mini-css-extract-plugin
export var container = "GitHubUserMessageForm-module--container--1jPwx";
export var username = "GitHubUserMessageForm-module--username--3f4gb";
export var email = "GitHubUserMessageForm-module--email--2ONcB";
export var form = "GitHubUserMessageForm-module--form--3ns2s";
export var description = "GitHubUserMessageForm-module--description--13TQt";
export var register = "GitHubUserMessageForm-module--register--233uV";
export var loading = "GitHubUserMessageForm-module--loading--2lr8m";
export var rotating = "GitHubUserMessageForm-module--rotating--lRNS1";